import { LINK_CAPABILITY_NODES } from '#pplx/frontend/composer-sdk/plugins/internal/capabilities/cap-link.js';
import { TYPEAHEAD_CAPABILITY_NODES } from '#pplx/frontend/composer-sdk/plugins/internal/capabilities/typeahead.js';
/**
 * Lexical node classes each capability kind needs registered on the editor's
 * `initialConfig`. `<Composer />` unions these across every mounted plugin
 * and merges the result with `CORE_NODES`.
 *
 * Only capability kinds that need custom nodes appear here — pure-behavior
 * capabilities (slot, plusMenu, primaryAction, filePicker, fileDrop,
 * filePaste, keyboard) contribute no nodes.
 *
 * When adding a new capability kind that needs custom nodes, add it here.
 *
 * @example
 * // Consumers never touch this map directly. They declare capabilities on
 * // their plugin; the Composer host resolves nodes automatically.
 * const askLinkPlugin = createPluginFactory({
 *   name: 'ask-link',
 *   capabilities: [{ kind: 'link', configure: () => ({ ... }) }],
 * });
 */
export const CAPABILITY_NODES = {
    link: LINK_CAPABILITY_NODES,
    typeahead: TYPEAHEAD_CAPABILITY_NODES,
};
//# sourceMappingURL=capabilityNodes.js.map